import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, profile } from 'config/config'; // Importing development configuration and user profile

/**
 * Class representing the summary bets report view.
 * @extends JetView
 */
export default class tableSummaryBetsReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var leftSplit = 1; // Variable to determine left split visibility

        // Custom data filter for summation in tree columns
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                refresh: function (master, node, value) {
                    var result = 0; // Variable to hold the summation result
                    var resultFormat = 0; // Variable to hold formatted result
                    master.data.each(function (obj) {
                        if (obj.$level == 1) result += obj[value.columnId]; // Summing values at level 1
                    });
                    // Formatting result based on column type
                    if (value.columnId === 'CantidadTickets') {
                        resultFormat = webix.i18n.intFormat(result);
                    } else {
                        resultFormat = webix.i18n.priceFormat(result);
                    }
                    node.firstChild.innerHTML = resultFormat; // Updating the node with formatted result
                },
            },
            webix.ui.datafilter.summColumn, // Extending existing summColumn filter
        );

        // Adjusting left split based on screen width
        webix.ready(function () {
            if (screen.width < 500) {
                leftSplit = 0; // No left split for small screens
            } else {
                leftSplit = 1; // Enable left split for larger screens
            }
        });

        // Returning the configuration for the treetable
        return {
            view: 'treetable', // View type
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            id: 'SummaryBetsReport', // Unique identifier for the component
            bready: function () {
                this.openAll(); // Expanding all rows on load
            },
            scrollY: true, // Enable vertical scrolling
            height: screen.width < 820 ? 450 : 0, // Dynamic height based on screen width
            columns: [
                // Column definitions for the treetable
                {
                    id: 'Date', // Column ID
                    header: _('Fecha Creación'), // Column header with localization
                    width: 300, // Column width
                    template: function (obj, common) {
                        if (obj.$group) return common.treetable(obj, common) + obj.value; // Grouped row template
                        return obj.Date; // Regular row template
                    },
                    footer: _('Total:'), // Footer text
                },
                { id: 'BetShop', header: _('Punto de Venta'), width: 150 }, // Bet shop column
                { id: 'DatePayment', header: _('Fecha de pago'), width: 150 }, // Payment date column
                {
                    id: 'BetShopPayment',
                    header: _('Punto Venta Pagó'), // Payment point column
                    width: 100,
                    sort: 'int', // Sorting type
                },
                { id: 'Cashier', header: _('Cajero'), width: 150 }, // Cashier column
                { id: 'UserId', header: _('Usuario Id'), width: 80 }, // User ID column
                { id: 'UserName', header: _('Usuario'), width: 150 }, // User name column
                { id: 'Date', header: _('Fecha Creación'), width: 150 }, // Creation date column
                {
                    id: 'Amount',
                    header: _('Valor'), // Amount column
                    format: webix.i18n.priceFormat, // Formatting function
                    exportType: 'number', // Export type
                    width: 100,
                    footer: { content: 'summColumn' }, // Footer content type
                },
                {
                    id: 'WinningAmount',
                    header: _('Premios'), // Winning amount column
                    format: webix.i18n.priceFormat, // Formatting function
                    exportType: 'number', // Export type
                    width: 100,
                    footer: { content: 'summColumn' }, // Footer content type
                },
                {
                    id: 'Tax',
                    header: _('Impuesto'), // Tax column
                    format: webix.i18n.priceFormat, // Formatting function
                    exportType: 'number', // Export type
                    width: 100,
                    footer: { content: 'summColumn' }, // Footer content type
                },
                {
                    id: 'WinningAmountTotal',
                    header: _('Premio Total'), // Total winning amount column
                    format: webix.i18n.priceFormat, // Formatting function
                    exportType: 'number', // Export type
                    width: 100,
                    footer: { content: 'summColumn' }, // Footer content type
                },
            ],
            on: {
                // Event handlers for the treetable
                onBeforeLoad: function () {
                    this.showOverlay(
                        // Show loading overlay before data load
                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                    );
                },
                onAfterLoad: function () {
                    this.hideOverlay(); // Hide loading overlay after data load
                },
            },
            ready: function () {
                if (!this.count()) {
                    // Check if there are no data items
                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                    this.showOverlay(
                        // Show no data overlay
                        "<div class='no-data' style='margin:75px; font-size:18px;'>" + _('No hay datos') + '</div>',
                    );
                }
            },
            autowidth: false, // Disable auto width
            math: true, // Enable math operations
            loadahead: devConfig.getDefaultDataFetch(), // Data fetch configuration
            leftSplit: leftSplit, // Left split configuration
            pager: 'pagerA', // Pager ID
            url: devConfig.geturlApi() + 'es/Financial/GetSummaryBetsReport', // Data source URL
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid component to initialize.
     */
    init(grid) {
        var url = grid.data.url; // Store the grid data URL
        grid.attachEvent('onAfterLoad', function () {
            // Grouping data by different criteria after loading
            $$('SummaryBetsReport').data.group({
                by: 'Punto', // Group by 'Punto'
                map: {
                    Punto: ['Punto'],
                    Agent: ['Agent'],
                    CountryId: ['CountryId'],
                    CountryIcon: ['CountryIcon'],
                    Partner: ['Partner'],
                    BetShop: ['BetShop'],
                    DatePayment: ['DatePayment'],
                    BetShopPayment: ['BetShopPayment'],
                    Cashier: ['Cashier'],
                    UserId: ['UserId'],
                    UserName: ['UserName'],
                    Amount: ['Amount', 'sum'], // Summing Amount
                    WinningAmount: ['WinningAmount', 'sum'], // Summing Winning Amount
                    Tax: ['Tax', 'sum'], // Summing Tax
                    WinningAmountTotal: ['WinningAmountTotal', 'sum'], // Summing Total Winning Amount
                },
            });
            $$('SummaryBetsReport').data.group({
                by: 'Agent', // Group by 'Agent'
                map: {
                    Agent: ['Agent'],
                    CountryId: ['CountryId'],
                    CountryIcon: ['CountryIcon'],
                    Partner: ['Partner'],
                    BetShop: ['BetShop'],
                    DatePayment: ['DatePayment'],
                    BetShopPayment: ['BetShopPayment'],
                    Cashier: ['Cashier'],
                    UserId: ['UserId'],
                    UserName: ['UserName'],
                    Amount: ['Amount', 'sum'],
                    WinningAmount: ['WinningAmount', 'sum'],
                    Tax: ['Tax', 'sum'],
                    WinningAmountTotal: ['WinningAmountTotal', 'sum'],
                },
            });
            $$('SummaryBetsReport').data.group({
                by: function (obj) {
                    return (
                        "<i class='flags " + obj.CountryIcon + "'></i>" + obj.CountryId // Grouping by Country with icon
                    );
                },
                map: {
                    CountryId: ['CountryId'],
                    CountryIcon: ['CountryIcon'],
                    Partner: ['Partner'],
                    BetShop: ['BetShop'],
                    DatePayment: ['DatePayment'],
                    BetShopPayment: ['BetShopPayment'],
                    Cashier: ['Cashier'],
                    UserId: ['UserId'],
                    UserName: ['UserName'],
                    Amount: ['Amount', 'sum'],
                    WinningAmount: ['WinningAmount', 'sum'],
                    Tax: ['Tax', 'sum'],
                    WinningAmountTotal: ['WinningAmountTotal', 'sum'],
                },
            });
            $$('SummaryBetsReport').data.group({
                by: function (obj) {
                    return (
                        "<i style='background-image:url(" +
                        profile.Partners.filter((item) => {
                            return item.id == obj.Partner; // Filtering partner image
                        })[0].image +
                        ") !important;' class='partner " +
                        obj.Partner +
                        "'></i>"
                    ); // Grouping by Partner with image
                },
                map: {
                    Partner: ['Partner'],
                    BetShop: ['BetShop'],
                    DatePayment: ['DatePayment'],
                    BetShopPayment: ['BetShopPayment'],
                    Cashier: ['Cashier'],
                    UserId: ['UserId'],
                    UserName: ['UserName'],
                    Amount: ['Amount', 'sum'],
                    WinningAmount: ['WinningAmount', 'sum'],
                    Tax: ['Tax', 'sum'],
                    WinningAmountTotal: ['WinningAmountTotal', 'sum'],
                },
            });
        });

        // Event handler for filtering data based on user input
        this.on(this.app, 'SummaryBetsReport:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Append start date
                        string1 = string1 + '&dateTo=' + date[1]; // Append end date
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Append other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert object filter to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Parse start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Append formatted start date
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Parse end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Append formatted end date
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
        });

        // Event handler for item click to navigate to user details
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user detail event
        });

        // Event handler for player selection to filter grid data
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data filtered by selected player
            );
        });
    }
}

// FILE DOCUMENTED
